const config = {
  localUrl:
    window?._env_?.REACT_APP_LOCAL_URL ||
    process.env.REACT_APP_LOCAL_URL ||
    'https://member.qualia-re.co.jp',
  BASE_API:
    window?._env_?.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    'https://api-member.qualia-re.co.jp',
  SSS_URL:
    window?._env_?.REACT_APP_SSS_URL ||
    process.env.REACT_APP_SSS_URL ||
    'https://dev.proflowtree.com',
  SSS_API_BASE_URL:
    window?._env_?.REACT_APP_SSS_API_BASE_URL ||
    process.env.REACT_APP_SSS_API_BASE_URL ||
    'https://dev.api.proflowtree.com',

  NODE_ENV: window?._env_?.NODE_ENV || process.env.NODE_ENV || 'development',
  APP_ENV: window?._env_?.APP_ENV || process.env.APP_ENV || 'production',

  USE_REFER: window?._env_?.USE_REFER || process.env.USE_REFER || 'development',
  REFER_URL:
    process.env.REACT_APP_REFER_URL ||
    'https://gw.qualia-re.co.jp',
};

export const getReferralLink = (memberCode: string, countryCode: string): string => {
  if (config.APP_ENV === 'staging') {
    return `https://gw-staging.proflowapps.com/?referralcode=${memberCode}`;
  }

  if (config.APP_ENV !== 'production') {
    return `https://gw-dev.proflowapps.com/?referralcode=${memberCode}`;
  }

  return `${config.REFER_URL}?referralcode=${memberCode}`;
};


export const getLocalUrl = (countryCode: string): string => {
  if (config.APP_ENV !== 'production') {
    return config.localUrl;
  }

  switch (countryCode) {
    case 'BR':
      return 'https://member.qualia-re.co.jp';
    case 'KH':
      return 'https://kh.qualia-re.co.jp';
    default:
      return config.localUrl;
  }
};

console.log('cofig', config);

export default config;
